exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".store-selection-page-container{flex:1;min-height:0}.close-button-hidden{opacity:0;pointer-events:none}.no-store-logout-container{padding:16px;display:flex;justify-content:center}", ""]);

// exports
